import Print from './Print'

export default Print



// WEBPACK FOOTER //
// ./src/containers/Modals/Print/index.js